import React, { useState } from "react";
import { motion } from "framer-motion";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import SectionHeading from "./SectionHeading";
import { staggerContainer, staggerItem } from "./Reveal";
import { projectsMeta } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

const images = {
    "cwsm.png": require("../cwsm.png"),
    "rehla.png": require("../rehla.png"),
    "sourcecodesyr_logo.jpg": require("../sourcecodesyr_logo.jpg"),
};

export default function Projects() {
    const { t } = useLanguage();
    const [selectedProject, setSelectedProject] = useState(null);

    return (
        <section id="projects" className="section">
            <div className="section__inner">
                <SectionHeading eyebrow={t.projects.eyebrow} title={t.projects.title} />

                <motion.div
                    className="projects-grid"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.2 }}
                >
                    {projectsMeta.map((project) => (
                        <motion.div
                            className="project-card"
                            key={project.id}
                            variants={staggerItem}
                            whileHover={{ y: -8 }}
                            onClick={() => setSelectedProject(project)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="project-card__image-wrap">
                                <img
                                    src={images[project.image]}
                                    alt={`${t.projects.items[project.id]} logo`}
                                />
                            </div>

                            <h3>{t.projects.items[project.id]}</h3>
                        </motion.div>
                    ))}

                    <motion.div
                        className="project-card project-card--more"
                        variants={staggerItem}
                        whileHover={{ y: -8 }}
                    >
                        <div className="project-card__image-wrap project-card__image-wrap--more">
                            <HiOutlineDotsHorizontal />
                        </div>
                        <h3>{t.projects.moreSoon}</h3>
                    </motion.div>
                </motion.div>

                {selectedProject && (
                    <div
                        className="project-modal-overlay"
                        onClick={() => setSelectedProject(null)}
                    >
                        <div
                            className="project-modal"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="project-modal__image-wrap">
                                <img
                                    src={images[selectedProject.image]}
                                    alt={`${t.projects.items[selectedProject.id]} preview`}
                                />
                            </div>

                            <h2>{t.projects.items[selectedProject.id]}</h2>

                            <p>{t.projects.desc[selectedProject.id]}</p>

                            {selectedProject.link && (
                                <>
                                    <p style={{ marginTop: "1.5rem" }}>
                                        Do you want to visit this website?
                                    </p>

                                    <button
                                        className="btn"
                                        onClick={() =>
                                            window.open(selectedProject.link, "_blank")
                                        }
                                    >
                                        Open Website
                                    </button>
                                </>
                            )}

                            <button
                                className="btn btn-secondary"
                                style={{ marginLeft: 10 }}
                                onClick={() => setSelectedProject(null)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}